import React from 'react';
import FigmaBadge from '../../../../Elements/FigmaBadge';
import { getClientInvoiceAutomationBadges } from '../../../../Helpers/invoiceAutomationClientHelper';

// A client's automated projects on the Clients list: "2 active" in green and "1 deactivated" in red; nothing when the
// client has none.
export default function InvoiceAutomationClientCounts({ activeCount = 0, deactivatedCount = 0 }) {
  const badges = getClientInvoiceAutomationBadges(activeCount, deactivatedCount);
  if (badges.length === 0) {
    return null;
  }

  return (
    <span className='d-inline-flex flex-wrap gap-1'>
      {badges.map((badge) => (
        <FigmaBadge
          key={badge.variant}
          variant={badge.variant}
          label={badge.label}
        />
      ))}
    </span>
  );
}
